import WizardTabs from '@v4/configuration-wizard/components/molecules/WizardTabs/WizardTabs';

export default WizardTabs;
